<template>
  <DialogTemplate
    class="board-filter"
    contentStyle="padding:1rem;margin:0; overflow:hidden"
  >
    <TrainerBoardFilter
      ref="form"
      :namespace="tmpNamespace"
      :tab="street"
      style="min-width: 31rem; min-height: 42.5rem; --padding-content: 0rem"
    />

    <template #dialog_actions>
      <v-btn
        data-tst="btn_reset_street"
        class="ml-auto"
        @click="clear"
      >
        {{ $t('btn.clear') }}
      </v-btn>
      <v-btn
        data-tst="btn_apply_filter"
        color="primary"
        class="ml-2"
        @click="apply"
        >{{ $t('btn.confirm') }}</v-btn
      >
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import TrainerBoardFilter from '@/components/Trainer/TrainerBoardFilter'

export default {
  name: 'PracticeFilterDialog',
  components: {
    TrainerBoardFilter,
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  methods: {
    clear() {
      this.$refs.form.clear()
    },
    apply() {
      const cpParams = {
        from_namespace: this.tmpNamespace,
        to_namespace: this.namespace,
        queryGroup: 'board-filter',
      }
      this.$store.dispatch('poker_copy_module', cpParams)
      this.close()
    },
    close() {
      this.$store.dispatch('router_rm_dialog', this.dialog.dialog)
    },
  },
  computed: {
    street() {
      return this.dialog.street
    },
    namespace() {
      return this.dialog.namespace || ''
    },
    tmpNamespace() {
      return this.dialog.tmpNamespace || ''
    },
  },
}
</script>
